export default "__VITE_ASSET__BdChFby7__"